import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row } from 'react-bootstrap';
import './style.scss';
import * as PageRoutes from '../../utils/route_pages';
import * as Assets from '../../utils/svg_assets';

import TopNavigation from '../../components/TopNavigation';
import ListVoucher from './listVoucher';
import { Base } from '../../components/RootLayout';
import { myVoucherCategory } from '../../utils/constant';
import Tabs from '../../components/Tabs';

const MyVoucher = (props) => {
  const { getUnusedVoucher, myvoucher } = props;
  const [activeTabs, setActiveTabs] = useState(1);
  const [activeKeyTabs, setActiveKeyTabs] = useState('allvoucher');
  const [hitParams, setHitParams] = useState({
    page: 1,
    is_used: false,
    is_expired: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getUnusedVoucher(hitParams).finally(() => setIsLoading(false));
  }, [hitParams]);

  const onChangeTabs = (tabActive, key) => {
    setActiveTabs(tabActive);
    setActiveKeyTabs(key);
    switch (key) {
      case 'allvoucher':
        setHitParams({
          page: 1,
        });
        break;
      case 'available':
        setHitParams({
          page: 1,
          is_available: true,
        });
        break;
      case 'used':
        setHitParams({
          page: 1,
          is_available: false,
        });
        break;
      default:
        break;
    }
  };

  return (
    <Base>
      <TopNavigation
        titlePage="My Vouchers"
        toPath={PageRoutes.reward}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="myvoucher-content">
        <div className="myvoucher-nav">
          <div className="d-flex wrapper-tab justify-content-between align-items-center p-0 overflow-unset">
            {myVoucherCategory.map((cat, index) => (
              <Tabs
                id={cat.id}
                key={index}
                name={cat.name}
                isActive={activeTabs}
                onClick={() => onChangeTabs(cat.id, cat.key)}
              />
            ))}
          </div>
          {activeKeyTabs === 'allvoucher' && (
            <Row className="lis-voucher-content">
              <ListVoucher
                myvoucher={myvoucher}
                activeTabs={activeKeyTabs}
                setActiveTabs={setActiveTabs}
                hitParams={hitParams}
                setHitParams={setHitParams}
                isLoading={isLoading}
              />
            </Row>
          )}
          {activeKeyTabs === 'available' && (
            <Row className="lis-voucher-content">
              <ListVoucher
                myvoucher={myvoucher}
                activeTabs={activeKeyTabs}
                setActiveTabs={setActiveTabs}
                hitParams={hitParams}
                setHitParams={setHitParams}
                isLoading={isLoading}
              />
            </Row>
          )}
          {activeKeyTabs === 'used' && (
            <Row className="lis-voucher-content">
              <ListVoucher
                myvoucher={myvoucher}
                activeTabs={activeKeyTabs}
                setActiveTabs={setActiveTabs}
                hitParams={hitParams}
                setHitParams={setHitParams}
                isLoading={isLoading}
              />
            </Row>
          )}
        </div>
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({
  myvoucher: state.RewardSM.myvoucher,
});

const mapDispatchToProps = (dispatch) => ({
  getUnusedVoucher: dispatch.RewardSM.getUnusedVoucher,
});

export default connect(mapStateToProps, mapDispatchToProps)(MyVoucher);
